import { Link } from "react-router-dom";
import { OUTDOOR_LIFESTYLE, CENTRAL_PARK_FEATURES, IMAGES } from "../data/site";
import { Reveal, SectionHeading } from "./Reveal";

export const Masterplan = () => (
  <section id="amenities" data-testid="amenities-section" className="py-20 sm:py-28 bg-[#FFFFFF]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-6">
          <SectionHeading index="04" eyebrow="Masterplan & Outdoor Lifestyle" title="A 3-acre central park at your doorstep" />
          <Reveal delay={0.15}>
            <p className="mt-6 text-[#4D7C0F] text-base sm:text-lg leading-relaxed max-w-xl">
              The masterplan reserves its heart for green — a sweeping central park threaded with trails, courts,
              gardens and quiet corners for every age.
            </p>
          </Reveal>

          <div className="mt-10">
            <p className="overline-tag mb-5">Masterplan Highlights</p>
            <div className="flex flex-wrap gap-2.5" data-testid="outdoor-lifestyle-tags">
              {OUTDOOR_LIFESTYLE.map((a) => (
                <span key={a} className="text-[13px] font-sub text-[#365314] bg-white border border-[#DCECC0] rounded-full px-4 py-2 hover:border-[#84CC16] transition-colors duration-300">
                  {a}
                </span>
              ))}
            </div>
          </div>

          <div className="mt-10">
            <p className="overline-tag mb-5">Inside the Central Park</p>
            <div className="flex flex-wrap gap-2.5" data-testid="central-park-tags">
              {CENTRAL_PARK_FEATURES.map((a) => (
                <span key={a} className="text-[13px] font-sub text-[#65A30D] bg-[#F4FAE8] border border-[#DCECC0] rounded-full px-4 py-2 hover:border-[#84CC16] hover:text-[#365314] transition-colors duration-300">
                  {a}
                </span>
              ))}
            </div>
          </div>

          <div className="mt-10">
            <Link
              to="/gated-community-properties-new-town-kolkata"
              data-testid="amenities-gated-link"
              className="inline-flex items-center gap-2 text-[#365314] text-sm font-sub font-semibold border border-[#9CCB58] rounded-full px-6 py-3 hover:bg-[#EAF5D6] hover:text-[#3F6212] active:scale-[0.98] transition-all duration-300"
            >
              Gated Community Properties in New Town
            </Link>
          </div>
        </div>

        <div className="lg:col-span-6 lg:sticky lg:top-28 space-y-6">
          <Reveal delay={0.2}>
            <div className="img-frame rounded-sm overflow-hidden">
              <div className="overflow-hidden rounded-sm">
                <img src={IMAGES.park} alt="Official central park plan of Vinayak 21 Acres with cabanas, grand lawn, courts and gardens" className="w-full h-auto rounded-sm bg-white" loading="lazy" />
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="img-frame rounded-sm overflow-hidden w-3/4 ml-auto -mt-16 relative z-10 hidden sm:block">
              <div className="overflow-hidden rounded-sm">
                <img src={IMAGES.garden} alt="Official masterplan of Vinayak 21 Acres showing towers, villas and the 3-acre central park" className="w-full h-auto rounded-sm bg-white" loading="lazy" />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
